import { render, staticRenderFns } from "./CreateCategoryButton.vue?vue&type=template&id=11803c26&"
import script from "./CreateCategoryButton.vue?vue&type=script&lang=ts&"
export * from "./CreateCategoryButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports